import { render, staticRenderFns } from "./UpdateOrderInfo.vue?vue&type=template&id=18a119b9&scoped=true&"
import script from "./UpdateOrderInfo.vue?vue&type=script&lang=js&"
export * from "./UpdateOrderInfo.vue?vue&type=script&lang=js&"
import style0 from "./UpdateOrderInfo.vue?vue&type=style&index=0&id=18a119b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a119b9",
  null
  
)

export default component.exports